<span>{{ fieldValue | formatLongText: 30 }}</span>

